export default "__VITE_ASSET__g6npiV2vV6kDx7palhTZNA__"